module.exports = __webpack_public_path__ + "24ad66123a680405ca1ccbb3b8761dd6.MP3";